// extracted by mini-css-extract-plugin
module.exports = {"language_tab":"blog_language_tab__1CBTQ","vertical_align_middle":"blog_vertical_align_middle__2vDgM","active":"blog_active__SM_gs","slug_icon":"blog_slug_icon__3u74T"};